export type OnboardingAgreementState = {
  executionDate: string;
  subsStartDate: string;
  subsEndDate: string;
  planLen: number;
  planId: string;
  planName: string;
  planWeeklyFee: number;
  planSetupFee: string;
  planMinimumPeriod: number;
  planWeeklyDistAllowance: number;
  planAdditionalDistCharge: number;
  insuranceCover: string;
  contactOwner: string;
  contactOwnerId: string;
  contactOwnerEmail: string;
  potentialId: string;
  pricingRecordId: string;
  quoteAddons: any[];
  // CBPOnboard fields - populated from pricing record
  reducedTermLengthWeeks: number;
  termReduction: string;
  weeklyDistanceAllowance: string;
  excessDistanceCost: string;
  minimumTerm: number;
  // Pricing fields for Zoho Sign template (GB and AU)
  lossAndDamageWaiverValue: string;
  a1TotalValue: string;
  a2TotalValue: string;
  a3TotalValue: string;
  totalAddonsValue: string;
  vehicleDriveawayPrice: string;
  // Used Vehicle Addendum fields - populated from pricing record
  replacementTyres: string;
  replacementBrakePadSet: string;
  replacementOrMachiningOfBrakeDiscs: string;
  // NSW EV Addendum fields (AU) - populated from plan service during NSW EV step
  nswTotalIncentiveExclGST: string;
  nswWeeklyIncentiveExclGST: string;
};

export type OnboardingAgreementAction =
  | { type: "SET_EXECUTION_DATE"; payload: string }
  | { type: "SET_SUBS_START_DATE"; payload: string }
  | { type: "SET_SUBS_END_DATE"; payload: string }
  | { type: "SET_PLAN_LEN"; payload: number }
  | { type: "SET_PLAN_ID"; payload: string }
  | { type: "SET_PLAN_NAME"; payload: string }
  | { type: "SET_PLAN_WEEKLY_FEE"; payload: number }
  | { type: "SET_PLAN_SETUP_FEE"; payload: string }
  | { type: "SET_PLAN_MINIMUM_PERIOD"; payload: number }
  | { type: "SET_PLAN_WEEKLY_DIST_ALLOWANCE"; payload: number }
  | { type: "SET_PLAN_ADDITIONAL_DIST_CHARGE"; payload: number }
  | { type: "SET_INSURANCE_COVER"; payload: string }
  | { type: "SET_CONTACT_OWNER"; payload: string }
  | { type: "SET_CONTACT_OWNER_ID"; payload: string }
  | { type: "SET_CONTACT_OWNER_EMAIL"; payload: string }
  | { type: "SET_ALL"; payload: Partial<OnboardingAgreementState> };

export const onboardingAgreementInitialState: OnboardingAgreementState = {
  executionDate: "",
  subsStartDate: "",
  subsEndDate: "",
  planLen: 0,
  planId: "",
  planName: "",
  planWeeklyFee: 0,
  planSetupFee: "",
  planMinimumPeriod: 0,
  planWeeklyDistAllowance: 0,
  planAdditionalDistCharge: 0,
  insuranceCover: "",
  contactOwner: "",
  contactOwnerId: "",
  contactOwnerEmail: "",
  potentialId: "",
  pricingRecordId: "",
  quoteAddons: [],
  reducedTermLengthWeeks: 0,
  termReduction: "",
  weeklyDistanceAllowance: "",
  excessDistanceCost: "",
  minimumTerm: 0,
  lossAndDamageWaiverValue: "",
  a1TotalValue: "",
  a2TotalValue: "",
  a3TotalValue: "",
  totalAddonsValue: "",
  vehicleDriveawayPrice: "",
  replacementTyres: "",
  replacementBrakePadSet: "",
  replacementOrMachiningOfBrakeDiscs: "",
  nswTotalIncentiveExclGST: "",
  nswWeeklyIncentiveExclGST: "",
};

export function onboardingAgreementReducer(state: OnboardingAgreementState, action: OnboardingAgreementAction): OnboardingAgreementState {
  switch (action.type) {
    case "SET_EXECUTION_DATE":
      return { ...state, executionDate: action.payload };
    case "SET_SUBS_START_DATE":
      return { ...state, subsStartDate: action.payload };
    case "SET_SUBS_END_DATE":
      return { ...state, subsEndDate: action.payload };
    case "SET_PLAN_LEN":
      return { ...state, planLen: action.payload };
    case "SET_PLAN_ID":
      return { ...state, planId: action.payload };
    case "SET_PLAN_NAME":
      return { ...state, planName: action.payload };
    case "SET_PLAN_WEEKLY_FEE":
      return { ...state, planWeeklyFee: action.payload };
    case "SET_PLAN_SETUP_FEE":
      return { ...state, planSetupFee: action.payload };
    case "SET_PLAN_MINIMUM_PERIOD":
      return { ...state, planMinimumPeriod: action.payload };
    case "SET_PLAN_WEEKLY_DIST_ALLOWANCE":
      return { ...state, planWeeklyDistAllowance: action.payload };
    case "SET_PLAN_ADDITIONAL_DIST_CHARGE":
      return { ...state, planAdditionalDistCharge: action.payload };
    case "SET_INSURANCE_COVER":
      return { ...state, insuranceCover: action.payload };
    case "SET_CONTACT_OWNER":
      return { ...state, contactOwner: action.payload };
    case "SET_CONTACT_OWNER_ID":
      return { ...state, contactOwnerId: action.payload };
    case "SET_CONTACT_OWNER_EMAIL":
      return { ...state, contactOwnerEmail: action.payload };
    case "SET_ALL":
      return { ...state, ...action.payload };
    default:
      console.log(`Error - incorrect action sent ${JSON.stringify(action)} ${JSON.stringify(state)}`);
      return state;
  }
}